<template>
    <b-col cols="auto">
        <b-row>
            <b-col class="form-inline col-auto pt-3">
                <label class="mr-sm-2">Value greater than:</label>
                <div class="input-icon-euro">
                    <b-input
                        type="text"
                        class="text-right"
                        :class="{'is-invalid': error}"
                        v-model="priceGreater"
                        v-numeric-only
                        @input="changePriceGreater"
                        placeholder="0.00"></b-input>
                </div>
                <button class="btn btn-close text-red" @click="resetFilter(['price:from', 'priceGreater'])">&times;</button>
            </b-col>
            <b-col class="form-inline col-auto pt-3">
                <label class="mr-sm-2">Value less than:</label>
                <div class="input-icon-euro">
                    <b-input
                        type="text"
                        class="text-right"
                        :class="{'is-invalid': error}"
                        v-model.number="priceLess"
                        v-numeric-only
                        @input="changePriceLess"
                        placeholder="0.00"></b-input>
                </div>
                <button class="btn btn-close text-red" @click="resetFilter(['price:to', 'priceLess'])">&times;</button>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import { numericOnly } from '@/directives/numericOnly'
    import { inputTypeTimer } from '@/utils'
    export default {
        name: 'PriceFilters',
        data() {
            return {
                priceLess: this.$route.query['filter[value:to]'] ? this.$route.query['filter[value:to]'] : '',
                priceGreater: this.$route.query['filter[value:from]'] ? this.$route.query['filter[value:from]'] : '',
                error: false,
                timeOut: null
            }
        },
        directives: {
            numericOnly
        },
        created() {
            this.changePriceGreater = inputTypeTimer(this.changePriceGreater, this.timeOut, 700)
            this.changePriceLess = inputTypeTimer(this.changePriceLess, this.timeOut, 700)
        },
        methods: {
            resetFilter(payload) {
                if (this[payload[1]] !== '') {
                    this[payload[1]] = ''
                    this.$emit(payload[1], {[payload[0]]: null})
                }
            },
            changePriceGreater() {
                this.inputValidation()
                this.$emit('priceGreater', {'value:from': this.priceGreater})
            },
            changePriceLess() {
                this.inputValidation()
                this.$emit('priceLess', {'value:to': this.priceLess})
            },
            inputValidation() {
                if (this.priceLess < this.priceGreater && this.priceLess !== '') {
                    this.error = true
                    this.$store.dispatch('globalAlertAction', {
                        type: 'error',
                        title: 'Not valid filter',
                        timeout: 10000
                    })
                    return false
                } else {
                    this.error = false
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/PriceFilters.vue